module.exports = __webpack_public_path__ + "img/coming-soon.062fee6f.svg";